import React, { type FunctionComponent } from 'react'
// Approved by the IPP team.
// eslint-disable-next-line @retailer-platform/no-restricted-imports
import { DatePicker } from '@mantine/dates'
import { DateIcon } from '@instacart/ids-core'
import { colors, borderRadius, fontWeight } from '../../../foundation'
import { DateRangePickerLabelText } from './DateRangePickerLabelText'

interface DateRangePickerDateInputProps {
  date: Date | null
  onChange: (date: Date) => void
  label: string
}

export const DateRangePickerDateInput: FunctionComponent<DateRangePickerDateInputProps> = ({
  date,
  onChange,
  label,
}) => (
  <div css={{ width: 260 }}>
    <DateRangePickerLabelText>{label}</DateRangePickerLabelText>
    <DatePicker
      allowFreeInput
      value={date}
      onChange={onChange}
      styles={{
        dropdown: {
          display: 'none',
        },
        input: {
          border: `1px solid ${colors.GRAYSCALE.X30}`,
          borderRadius: borderRadius.X8,
          height: '40px',
          fontSize: '15px',
          fontWeight: fontWeight.SEMIBOLD,
        },
      }}
      icon={<DateIcon size={18} />}
    />
  </div>
)
